import { generatePath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the compliance menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getComplianceMenu({ businessEntityUuid, order }) {
  return processMenu({
    title: 'Compliance',
    itemId: 'compliance',
    icon: 'todo-fill.svg',
    path: generatePath(ROUTES.entityComplianceOverview, { businessEntityUuid }),
    order,
  });
}
